import { render, staticRenderFns } from "./ReceiptCopyFullscreenPreview.vue?vue&type=template&id=0c996988&scoped=true&"
import script from "./ReceiptCopyFullscreenPreview.vue?vue&type=script&lang=js&"
export * from "./ReceiptCopyFullscreenPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c996988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
